import { render, staticRenderFns } from "./SubEmotionList.vue?vue&type=template&id=a0ccbedc&scoped=true&"
import script from "./SubEmotionList.vue?vue&type=script&lang=js&"
export * from "./SubEmotionList.vue?vue&type=script&lang=js&"
import style0 from "./SubEmotionList.vue?vue&type=style&index=0&id=a0ccbedc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ccbedc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VContainer,VIcon,VRow,VSimpleTable,VSkeletonLoader})
